import { observable, action, autorun, computed, toJS } from 'mobx'
import http from 'src/helper/http'
import localstorage from 'src/helper/localstorage'

export default class {
  @observable data = {
    UserListByUids: [],//当前左边栏用户，后端
    conversationList: [],//当前左边栏用户，声网
    currentUser: {},//当前用户
    messageContent: { hasMore: false, list: [] },//窗口聊天内容
    messageContentList: {},//本地缓存
    preUsers: []
  }

  @action async getRongCloudApiKey(map) {
    let d = await http.post('/api/web/getRongCloudApiKey', map)
    if (d.code == 0) {
      return d.res
    }
    return ""
  }

  @action async getUserListByUids(map) {
    let d = await http.post('/api/admin/getUserListByUids', map)
    if (d.code == 0) {
      this.data.UserListByUids = d.res
      if (d.res.length > 0) {
        this.data.currentUser = d.res[0]
      }
      return d.res
    }
    this.data.UserListByUids = []
    return []
  }

  @action async SetConversationList(d) {
    this.data.conversationList = d
  }

  @action async setCurrentUser(d) {
    this.data.currentUser = d
  }

  @action async setMessageContent(d, targetId) {
    this.data.messageContent = d
    this.data.messageContentList[`user${targetId}`] = d
  }

  @action async msgPush(item) {
    if (item.sentTime == undefined || item.sentTime == 0) {
      item.sentTime = parseInt((new Date()).getTime())
    }
    // console.log(this.data.messageContentList, this.data.messageContentList[`user${item.targetId}`])
    if (this.data.messageContentList[`user${item.targetId}`] == undefined) {
      this.data.messageContentList[`user${item.targetId}`] = { hasMore: false, list: [] }
    }
    let list = toJS(this.data.messageContentList[`user${item.targetId}`].list)
    list.push(item)
    this.data.messageContentList[`user${item.targetId}`].list = list
    console.log('接收', this.data.currentUser, item)
    // if (this.data.currentUser.uid == item.senderUserId) {
    this.data.messageContent.list = this.data.messageContentList[`user${this.data.currentUser.uid}`].list
    // }
    //已读红点
    for (let i = 0; i < this.data.UserListByUids.length; i++) {
      if (item.targetId != this.data.currentUser.uid && this.data.UserListByUids[i].uid == item.targetId) {
        this.data.UserListByUids[i].isRead = false
      }
    }
  }

  @action async changeUser(d) {
    console.log('changeUser', d)
    this.data.messageContent = { hasMore: false, list: [] }
    if (this.data.messageContentList[`user${d.uid}`] == undefined) {
      this.data.messageContentList[`user${d.uid}`] = { hasMore: false, list: [] }
    }
    this.data.messageContent = this.data.messageContentList[`user${d.uid}`]
    this.setCurrentUser(d)

    //已读红点
    let inList = false //是否在左边栏
    for (let i = 0; i < this.data.UserListByUids.length; i++) {
      if (this.data.UserListByUids[i].uid == d.uid) {
        this.data.UserListByUids[i].isRead = true
        inList = true
      }
    }
    if (inList == false) {
      let list = this.data.UserListByUids
      list.splice(0, 0, d)
      this.data.UserListByUids = list
    }
  }

  @action async MyAccount() {
    let d = await http.post('/api/web/MyAccount', {})
    if (d.code == 0 && d.res && d.res.uid > 0) {
      return true
    } else {
      return false
    }
  }

  @action async GetUserInfo(uid) {
    let d = await http.post('/api/admin/getUserIdentityNobilityByDuid', { "duid": parseInt(uid) })
    if (d.code == 0 && d.res && d.res.uid > 0) {
      let arr = []
      arr.push(d.res)
      this.data.preUsers = arr
    } else {
      this.data.preUsers = []
    }
  }

  @action async SetPreUsersEmpty() {
    this.data.preUsers = []
  }
}



// WEBPACK FOOTER //
// ./store/chat.js